import { type PropsWithChildren } from 'react';

import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { isIOS, isMacOs, isSafari } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import SmartBanner from 'react-smartbanner';

import { useAppContext } from '@/app/Providers';

import { IconFilledStar } from '../Icons';
import '/node_modules/react-smartbanner/dist/main.css';

export const SmartBannerProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const location = document.location.pathname;
  const { t } = useTranslation('common');

  const isAdmin = location?.includes('/admin');

  const { isShowBanner } = useAppContext();

  if (isAdmin || isSafari || !isShowBanner) {
    return <>{children}</>;
  }

  return (
    <>
      <Box
        display={{ md: 'none' }}
        sx={{
          '.smartbanner-container': {
            marginLeft: 3,
          },
          '.smartbanner': {
            backgroundImage: '/images/smart-banner-logo.png',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          },
          '.smartbanner-icon': {
            width: 10,
            height: 10,
          },
          '.smartbanner-info': {
            width: 'calc(99% - 230px)',
            textShadow: 'none',
          },
          '.smartbanner-description': {
            display: 'none',
          },
          '.smartbanner-wrapper a': {
            padding: 0,
            background: 'none',
            boxShadow: 'none',
          },
          '.smartbanner-wrapper': {
            marginLeft: 5,
          },
          '.smartbanner-close': {
            position: 'absolute',
            right: 0,
            top: 3,
            fontSize: '24',
            boxShadow: 'none',
            background: 'none',
            textShadow: 'none',
          },
          '.smartbanner-title': {
            fontSize: 18,
            color: 'gray.900',
          },
          '.smartbanner-button': {
            background: 'none',
          },
          '.smartbanner-button-text': {
            background: 'none',
          },
          '.smartbanner-android': {
            boxShadow: 'none',
          },
          '.smartbanner-button-text:hover': {
            background: 'none',
          },
        }}
      >
        <SmartBanner
          force={isIOS || isMacOs ? 'ios' : 'android'}
          ignoreIosVersion
          daysHidden={1}
          position="top"
          title={
            (
              <HStack columnGap={1}>
                <IconFilledStar />
                <IconFilledStar />
                <IconFilledStar />
                <IconFilledStar />
                <IconFilledStar />
                <Text color="gray.600" fontSize={14} ml="1">
                  4.8
                </Text>
              </HStack>
            ) as ExplicitAny
          }
          button={
            <Button height={7} px={3} variant="@primary" size="sm">
              {t('actions.openInApp')}
            </Button>
          }
        />
      </Box>

      {children}
    </>
  );
};
